export default function () {
  return {
    partes: {
      data: [],
      links: {},
      meta: {},
    },
  };
}
